// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__primary_bbdb7d', '__primary_Fallback_bbdb7d'"},"className":"__className_bbdb7d","variable":"__variable_bbdb7d"};